import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { usePageTitle } from '../../hooks/usePageTitle';
import { PurchaseOrdersContent } from '../../components/billing/purchase-orders/PurchaseOrdersContent';

const FILTER_STORAGE_KEYS = {
    vendorId: 'fv_billing_poVendorFilter',
    fulfillmentStatus: 'fv_billing_poFulfillmentFilter',
    billingStatus: 'fv_billing_poBillingFilter',
    needsAttention: 'fv_billing_poNeedsAttentionFilter',
    practiceId: 'fv_billing_poPracticeFilter'
} as const;

export function PurchaseOrdersList() {
    usePageTitle('Purchase orders');
    const { setTitle, setSubtitle } = usePageHeader();
    const navigate = useNavigate();
    // The open drawer is URL-driven, so links are shareable and the browser
    // back button restores it.
    const { poId } = useParams<{ poId: string }>();
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        setTitle('Purchase orders');
        setSubtitle(`${totalCount} total`);
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [totalCount, setTitle, setSubtitle]);

    return (
        <PurchaseOrdersContent
            openPurchaseOrderId={poId ?? null}
            onOpenPurchaseOrder={(id) => navigate(`/billing/purchase-orders/${id}`)}
            onClosePurchaseOrder={() => navigate('/billing/purchase-orders')}
            filterStorageKeys={FILTER_STORAGE_KEYS}
            onTotalCountChange={setTotalCount}
        />
    );
}
